
document.addEventListener("DOMContentLoaded", function () {
  function applyShadowStyles() {
    const shadowHost = document.querySelector("#app-embed");
    if (shadowHost && shadowHost.shadowRoot) {
      const style = document.createElement("style");
      style.textContent = `
    ._inline_1q1d2_47 ._formContainer_1q1d2_30{
        max-width:50% !important;
        border: 1px solid #ccc;
        border-radius: 4px;
    }
    ._formFieldset_cit2d_82{
        padding:20px !important;
    }
    section._formHeader_cit2d_24 {
        margin-bottom: 0px !important;
        padding: 20px;
        border-bottom:1px solid #ccc;
    }
    ._formFieldContainer_ck6wz_5 {
        flex-direction: column-reverse !important;
        margin-bottom: 15px !important;
    }
    ._selectContainer_12thd_6{
        margin-bottom: 15px !important;
    }
    ._formFileInputField_ehvsf_5{
        background:#F9F9F9 !important;
    }
    ._formFileInputButton_ehvsf_18{
        background:none !important;
        position: relative;
        font-size: 14px;
        color: #000;
        text-transform: capitalize;
        font-weight: 500;
    }
    ._formFileInputButton_ehvsf_18:before {
        content: ""!important;
        position: absolute!important;
        top: 8px;
        left: -16px;
        width: 16px;
        height: 16px;
        border-radius: 50px;
        background-image: url('https://cdn.shopify.com/s/files/1/0907/9658/9322/files/attachment-svgrepo-com.svg');
        background-size: contain;
    }
    ._formFieldContainer_ck6wz_5 label {
        top: inherit !important;
        position: inherit !important;
        transform: none !important;
        left: 0px !important;
        color: #0a1a56 !important;
        margin-bottom: 5px !important;
        font-weight: 500 !important;
        font-size: 16px !important;
        font-family: 'Inter', sans-serif !important;
    }
    ._label_12thd_10 _textBody_2aowh_10,
    ._textBody_2aowh_10{
        color: #0a1a56 !important;
        margin-bottom: 5px !important;
        font-weight: 500 !important;
        font-size: 16px !important;
    }
    ._textHeading_2aowh_35{
        color:#0a1a56 !important;
    }
        @media screen and (max-width:768px){
          ._inline_1q1d2_47 ._formContainer_1q1d2_30{
            max-width:100% !important;
          }
          ._inline_1q1d2_47{
            overflow:inherit !important;
          }
          ._container_3eyaa_70 {
            display:inherit !important;
          }
        }
      `;
      shadowHost.shadowRoot.appendChild(style);
      return true;
    }
    return false;
  }

  const interval = setInterval(() => {
    if (applyShadowStyles()) {
      clearInterval(interval);
    }
  }, 500);
});


// form textarea code
(function () {
  function apply() {
    const host = document.querySelector('shopify-forms-embed');
    if (!host) return;

    const root = host.shadowRoot;
    if (!root) return;

    const textareas = root.querySelectorAll('form textarea');

    textareas.forEach(function (textarea) {
      if (textarea.dataset.done) return;
      textarea.dataset.done = "true";
      const MAX = 300;

      textarea.setAttribute("maxlength", MAX);

      const topP = document.createElement("p");
      topP.textContent = "Max. 300 words";
      topP.classList.add("char-limit-info");
      topP.style.color = "#0a1a56";
      topP.style.fontSize = "14px";
      topP.style.position = "absolute";
      topP.style.top = "-36px";

      textarea.insertAdjacentElement("beforebegin", topP);

      const p = document.createElement("p");
      p.textContent = "Maximum allowed length is 300 characters";
      p.classList.add("char-limit-warning");

      p.style.display = "none";
      p.style.color = "red";
      p.style.fontSize = "14px";
      p.style.marginTop = "5px";

      textarea.insertAdjacentElement("afterend", p);

      textarea.addEventListener("input", function () {
        if (this.value.length > MAX) {
          this.value = this.value.substring(0, MAX);
        }

        if (this.value.length >= MAX) {
          p.style.display = "block";
        } else {
          p.style.display = "none";
        }
      });
    });
  }

  apply();
  setTimeout(apply, 1000);
  setTimeout(apply, 3000);

  const observer = new MutationObserver(function () {
    apply();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {

    const formEmbed = document.querySelector('shopify-forms-embed');
    if (formEmbed && formEmbed.shadowRoot) {

      const style = document.createElement('style');
      style.textContent = `
    ._inline_1q1d2_47 [aria-label="Success"] ._gridItemContent_1q1d2_257{
          display:flex;
          align-items:center;
          height:100%;
        }
        ._inline_1q1d2_47 [aria-label="Success"] ._formBannerHeading_z5ku3_9{
              justify-content: center;
              color:#0a1a56 !important;
          }
        ._inline_1q1d2_47 [aria-label="Success"] ._textBody_2aowh_10{
          text-align:center;
        }
      `;

      formEmbed.shadowRoot.appendChild(style);
    }

  }, 2000);
});